import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    APPLY_STATUS_FAILURE,
    APPLY_STATUS_PENDING,
    APPLY_STATUS_SUCCESS,
    clearApplyField
} from "../../actions/ApplyFieldActions";
import useApplyFieldStatus from "../../hooks/useApplyFieldStatus";

function ApplyField({input, placeholder, title, onClickApply, onClickRemove, errorMessage, removable}) {
    const {name, value} = input;
    const fieldData = useSelector(state => state.applyField[name]);
    const dispatch = useDispatch();
    const {checkStatus} = useApplyFieldStatus(name);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (!!value) {
            // onApply();
        }
    }, []);

    const getError = () => {
        return fieldData ? fieldData.error : '';
    }

    const onApply = () => {
        dispatch(onClickApply(name, value, errorMessage));
    }

    const onRemove = () => {
        dispatch(clearApplyField(name));
        if (typeof onClickRemove === 'function') {
            onClickRemove();
        }
    }

    const handleInputChange = (e) => {
        const {value} = e.target;
        // Regular expression to match special characters
        const regex = /[^a-zA-Z0-9 ]/g;
        // If value contains special characters, remove them
        if (regex.test(value)) {
            e.target.value = value.replace(regex, '');
        }
        input.onChange(e);
    }

    const handleInputFocus = () => {
        setIsActive(true);
    }

    const handleInputBlur = () => {
        setIsActive(false);
    }

    return <div className={`promo-code-wrap ${checkStatus(APPLY_STATUS_SUCCESS) ? 'promo-code-applied-wrap' : ''}`}>
        {!checkStatus(APPLY_STATUS_SUCCESS) ? (
            <div className="promo-code-field__container">
                <div className={`promo-code-field ${isActive ? 'active' : ''} ${checkStatus(APPLY_STATUS_FAILURE) ? 'control-error' : ''}`}>
                    <input
                        {...input}
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                        onBlur={handleInputBlur}
                        className={`control-input ${checkStatus(APPLY_STATUS_FAILURE) ? 'control-error' : ''}`}
                        placeholder={placeholder}
                    />
                    <button
                        type="button"
                        className="btn_v3 btn_v3-md btn_v3-primary btn_v3-blue"
                        onClick={onApply}
                        disabled={!value || checkStatus(APPLY_STATUS_PENDING)}
                    >
                        Apply
                    </button>
                </div>
                {checkStatus(APPLY_STATUS_FAILURE) && <div className="error-msg">{getError()}</div>}
            </div>
        ) : (
            <div className="promo-code-applied">
                <p>{title}</p>
                <div className="promo-code-applied__value">
                    <img src="/_core/assets/themes/v5/assets/img/form3/applied-icon.svg" alt="" />
                    <span>{value}</span>
                    {removable && (
                        <div className="promo-code-applied__remove" onClick={onRemove}>
                            <svg width="9" height="9" viewBox="0 0 9 9" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.16628 0.653925C7.84125 0.3289 7.31421 0.3289 6.98975 0.653925L4.41016 3.23385L1.83057 0.653925C1.50554 0.3289 0.979062 0.3289 0.654037 0.653925C0.329011 0.97895 0.329011 1.50543 0.654037 1.83046L3.23362 4.41027L0.653925 6.99019C0.3289 7.31522 0.3289 7.8417 0.653925 8.16672C0.816382 8.32918 1.02931 8.41052 1.24225 8.41052C1.45518 8.41052 1.66833 8.32929 1.83057 8.16672L4.41016 5.58691L6.98975 8.16672C7.1522 8.32918 7.36513 8.41052 7.57807 8.41052C7.791 8.41052 8.00382 8.32929 8.16639 8.16672C8.49141 7.8417 8.49141 7.31522 8.16639 6.99019L5.58669 4.41038L8.16628 1.83057C8.4913 1.50554 8.4913 0.97895 8.16628 0.653925Z"
                                    fill="#56657B"
                                />
                            </svg>
                        </div>
                    )}
                </div>
            </div>
        )}
    </div>
}

export default ApplyField;
